import React from 'react';
import { Card, CardContent, CardActions } from '@material-ui/core';
import FormButton from '../../library/form/components/FormActionButton2';

const DocCardContainer = (props) => {
const {
formObject,
rowKey,
children,
containerClass, // optional override
actionClass, // optional override
actionsVisible = true,
} = props;

const cardClass = containerClass || 'uiCard';
const gridClass = 'uiCardGrid';
const bodyClass = 'uiCardBody';
const actionsSlotClass = actionClass || 'uiCardActions';

return (
<Card className={cardClass}>
<div className={gridClass}>
<CardContent className={bodyClass}>
{children}
</CardContent>
    <CardActions className={actionsSlotClass}>
      {actionsVisible && (
        <>
          <FormButton
            formObject={formObject}
            rowKey={rowKey}
            starIcon="edit"
            onlyIcon={true}
            tooltip="Edit"
            starIconClassName="uiColorNeutralAction"
            action={{ actionId: 'edit', paramName: 'editAction', actionParam: {}, containerKey: 'popup' }}
          />
          <FormButton
            formObject={formObject}
            rowKey={rowKey}
            starIcon="clear"
            onlyIcon={true}
            tooltip="Delete"
            starIconClassName="uiColorNegativeAction"
            action={{ actionId: 'del', paramName: 'delAction', actionParam: {}, containerKey: 'row' }}
          />
        </>
      )}
    </CardActions>
  </div>
</Card>
);
}

export default DocCardContainer;